import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveApplication: ['application', 'onSuccess', 'onError'],
  removeApplication: ['application', 'onSuccess', 'onError'],
  applicationError: ['error']
})

const saveApplication = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeApplication = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const applicationError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.APPLICATION_ERROR]: applicationError,

  [Types.SAVE_APPLICATION]: saveApplication,
  [Types.REMOVE_APPLICATION]: removeApplication,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as ApplicationTypes,
  Creators as ApplicationActions
}
